import { TemplateType } from './types';

// 🎨 등급 리스트 - A/B/C/D 4등급 체계
// 🆕 중앙화된 상수 사용 권장: import { GRADE_LIST } from '../../../../constants/grades'
export const GRADE_LIST = [
  { value: "A", label: "A등급", color: "#10b981", icon: "🟢" },
  { value: "B", label: "B등급", color: "#3b82f6", icon: "🔵" },
  { value: "C", label: "C등급", color: "#f59e0b", icon: "🟡" },
  { value: "D", label: "D등급", color: "#ef4444", icon: "🔴" }
];

// 📋 필드 라벨
export const FIELD_LABELS = {
  status: '상태',
  priceOffer: '검수금액',
  finalPrice: '최종금액',
  trackingNumber: '택배 송장번호',
  storeCode: '매장코드',
  grade: '등급',
  deductionReason: '차감 사유',
  remark: '관리자 메모'
};

// 🔔 알림톡 템플릿 옵션
export const TEMPLATE_OPTIONS: { 
  value: TemplateType; 
  label: string; 
  description: string; 
  requiresReason?: boolean; 
  disabled?: boolean;
  partnerOnly?: boolean; // 🆕 거래처 전용 여부
}[] = [
  { value: '신청완료', label: '신청완료', description: '매입 신청 접수 완료 안내' },
  { value: '택배접수', label: '택배접수 (준비중)', description: '택배 수거 일정 안내 - 현재 서비스 준비중', disabled: true },
  { value: '입고완료', label: '입고완료', description: '기기 입고 완료 안내' },
  { value: '검수중', label: '검수중 (준비중)', description: '기기 검수 진행 중 안내 - 현재 서비스 준비중', disabled: true },
  { value: '가격안내', label: '가격안내', description: '품목별 등급 자동 선택 · 개별 발송' },
  { value: '매입 불가', label: '매입 불가', description: '매입 불가 안내 및 반송', requiresReason: true },
  { value: '반송', label: '반송', description: '기기 반송 완료 안내', requiresReason: false },
  { value: '완료', label: '완료', description: '매입 완료 안내' },
  { value: '정보입력요청', label: '📋 정보입력요청 (거래처)', description: '주소/계좌 입력 요청 (거래처 전용)', partnerOnly: true },
];

// 📊 상태 라벨
export const STATUS_LABELS: Record<string, string> = {
  success: '성공',
  failure: '실패',
};

// 🔗 API 엔드포인트
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api-4iuywcitfq-uc.a.run.app'; 